import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"
import ProductType from "types/enums/ProductType"

import { QuantityChips } from "components/table/columnComponents/QuantityChips"

interface CellProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const ThermostatsCell = ({ cell: { row, getValue } }: CellProps) => {
  const quantity = Number(getValue().value)

  if (!quantity) return null

  return (
    <QuantityChips
      items={[{ productType: ProductType.Thermostat, quantity, label: "Thermostats" }]}
      idSeed={row.original.rowSettings.id}
    />
  )
}
